import React from 'react';
import { LoginForm } from '../components/Auth/LoginForm';
import loginBG from '../assets/loginscreen-bg.jpg';
import { StyledMain, StyledSection } from './styles';
const Login = () => {
  return (
    <StyledSection bgImage={loginBG} className='tma_app_content'>
      <StyledMain>
        <LoginForm />
      </StyledMain>
    </StyledSection>
  )
}

export  {Login}